import { p as promiseResolve, b as bootstrapLazy } from './index-34a04543.js';
import './main-b09de755.js';

/*
 Stencil Client Patch Esm v2.17.1 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["pf-button_6",[[33,"pf-button",{"theme":[1537],"size":[1537],"mode":[1537],"type":[1537],"loading":[1540],"disabled":[1540],"block":[1540],"tempDisabled":[32]},[[2,"click","onClick"]]],[33,"pf-checkbox",{"class":[1],"mode":[1537],"disabled":[1540],"block":[1540],"switchable":[1540],"checked":[1540],"value":[1537],"ID":[32]}],[33,"pf-dropdown",{"class":[1537],"isOpen":[1540,"is-open"],"mode":[1537],"hideArrow":[1540,"hide-arrow"],"openOnButtonClick":[1540,"open-on-button-click"],"fixedStyles":[32],"windowWidth":[32]},[[8,"click","listenDocumentClick"],[9,"resize","listenBodyResize"]]],[1,"pf-image",{"src":[1537],"fallbackSrc":[1537,"fallback-src"],"alt":[1537],"width":[1538],"height":[1538],"loading":[1540],"rounded":[1540],"hasSrcfailed":[32],"hasFallbackSrcfailed":[32],"imageLoading":[32]}],[1,"pf-phone-input"],[33,"pf-select",{"size":[1537],"label":[1537],"type":[1537],"mode":[1537],"disabled":[1540],"block":[1540],"options":[1040],"value":[1537],"ID":[32]}]]]], options);
  });
};

export { defineCustomElements };
